module.exports = __webpack_public_path__ + "images/simple_example.png";